export interface IPluralizationForms {
  single: string;
  multiple: string;
}
